import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

const HUB_MESSAGING_COMPLEX = {
  updateAutomations: function (store, hubIndex) {
    return new Promise( (resolve, reject) => {
      var hub = store.state.hubs[hubIndex];

      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: store.state.user.uuid
      });
      store.dispatch('readHubInstructions', {
        messagingHook: messagingHook,
        hubUUID: hub.uuid,
      })
      .then( response => {
        var instructionList = response.body.bodyContent.instructionList;
        store.dispatch('getEventMasks', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
        })
        .then( response => {
          var maskList = response.body.bodyContent.maskList;
            store.dispatch('readHubWatches', {
              messagingHook: messagingHook,
              hubUUID: hub.uuid,
            })
            .then( response => {
              var watchList = response.body.bodyContent.watchList;

              var instructionListOrderByGroupId = [];
              var instructionListOrderByGroupIdIterator = -1;
              var prevGroupId = 0;
              for(var i = 0; i < instructionList.length; i++){
                var eventIdToWatch = instructionList[i].eventIdToWatch;
                if(eventIdToWatch >> 8 == CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX){
                  var groupId = ( eventIdToWatch & 0xFF ) >> 3;
                  if(groupId != prevGroupId){
                    instructionListOrderByGroupId.push({
                      groupId: groupId,
                      instructions: [instructionList[i]],
                    })
                    prevGroupId = groupId;
                    instructionListOrderByGroupIdIterator++;
                  }else{
                    instructionListOrderByGroupId[instructionListOrderByGroupIdIterator].instructions.push(instructionList[i]);
                  }
                }
              }

              var automationWidgets = [];
              for(i = 0; i < instructionListOrderByGroupId.length; i++){
                //eventId for cool on
                var coolOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (instructionListOrderByGroupId[i].groupId & 0xFF) << 3);
                //eventId for cool off
                var coolOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (instructionListOrderByGroupId[i].groupId & 0xFF) << 3) + 1;
                //eventId for heat on
                var heatOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (instructionListOrderByGroupId[i].groupId & 0xFF) << 3) + 2;
                //eventId for heat off
                var heatOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (instructionListOrderByGroupId[i].groupId & 0xFF) << 3) + 3;

                var coolOnCommand = [];
                var coolOffCommand = [];
                var heatOnCommand = [];
                var heatOffCommand = [];

                for(var j = 0; j < instructionListOrderByGroupId[i].instructions.length; j++){
                  if(instructionListOrderByGroupId[i].instructions[j].eventIdToWatch == coolOnActualEventId){
                    coolOnCommand = instructionListOrderByGroupId[i].instructions[j].commandToSend;
                  }else if(instructionListOrderByGroupId[i].instructions[j].eventIdToWatch == coolOffActualEventId){
                    coolOffCommand = instructionListOrderByGroupId[i].instructions[j].commandToSend;
                  }else if(instructionListOrderByGroupId[i].instructions[j].eventIdToWatch == heatOnActualEventId){
                    heatOnCommand = instructionListOrderByGroupId[i].instructions[j].commandToSend;
                  }else if(instructionListOrderByGroupId[i].instructions[j].eventIdToWatch == heatOffActualEventId){
                    heatOffCommand = instructionListOrderByGroupId[i].instructions[j].commandToSend;
                  }
                }
                var isActive = true;
                for(j = 0; j < maskList.length; j++){
                  if (maskList[j].eventId == coolOnActualEventId){
                    isActive = false;
                  }
                }
                var coolOnWatchIndex = -1;
                var coolOffWatchIndex = -1;
                var heatOnWatchIndex = -1;
                var heatOffWatchIndex = -1;
                for(j = 0; j < watchList.length; j++){
                  if(watchList[j].eventId == coolOnActualEventId){
                    coolOnWatchIndex = j;
                  }else if(watchList[j].eventId == coolOffActualEventId){
                    coolOffWatchIndex = j;
                  }else if(watchList[j].eventId == heatOnActualEventId){
                    heatOnWatchIndex = j;
                  }else if(watchList[j].eventId == heatOffActualEventId){
                    heatOffWatchIndex = j;
                  }
                }
                if(coolOnWatchIndex != -1 && coolOffWatchIndex != -1){
                  var season = 'summer';
                  var sensorUUID = watchList[coolOnWatchIndex].deviceUUID;
                  var sensorParameterId = watchList[coolOnWatchIndex].parameterId;
                  var setPoint = (watchList[coolOnWatchIndex].valueOfChange + watchList[coolOffWatchIndex].valueOfChange)/2;
                }else if(heatOnWatchIndex != -1 && heatOffWatchIndex != -1){
                  season = 'winter';
                  sensorUUID = watchList[heatOnWatchIndex].deviceUUID;
                  sensorParameterId = watchList[heatOnWatchIndex].parameterId;
                  setPoint = (watchList[heatOnWatchIndex].valueOfChange + watchList[heatOffWatchIndex].valueOfChange)/2;
                }else{
                  //Code should not reach here
                  continue;
                }

                automationWidgets.push({
                  name: store.getters.language.texts.LuxinWidget_temperatureAutomation + '-' + (i+1),
                  color: 0,
                  type: "temperatureAutomationWidget",
                  hubUUID: hub.uuid,
                  visible: true,
                  settings: {
                    sensorUUID: sensorUUID,
                    sensorParameterId: sensorParameterId,
                    season: season,
                    setPoint: setPoint,
                    coolOnCommand: coolOnCommand,
                    coolOffCommand: coolOffCommand,
                    heatOnCommand: heatOnCommand,
                    heatOffCommand: heatOffCommand,
                    coolOnGeneratedCommand: [],
                    coolOffGeneratedCommand: [],
                    heatOnGeneratedCommand: [],
                    heatOffGeneratedCommand: [],
                    groupId: instructionListOrderByGroupId[i].groupId,
                    isActive: isActive,
                  }
                });
              }
              for(i = 0; i < automationWidgets.length; i++){
                var prevWidget = store.getters.getTemperatureAutomationWidgetByGroupId(automationWidgets[i].settings.groupId);
                if(prevWidget != -1){
                  prevWidget.settings.season = automationWidgets[i].settings.season;
                  prevWidget.settings.setPoint = automationWidgets[i].settings.setPoint;
                  prevWidget.settings.isActive = automationWidgets[i].settings.isActive;
                  store.commit('editWidget', {
                    widgetIndex: prevWidget.index,
                    widget: prevWidget,
                  });
                }else{
                  store.commit('addWidget', automationWidgets[i]);
                }
              }
              var widgetCount = store.state.widgets.length;
              var widgetFound = false;
              for(i = widgetCount - 1; i >= 0; i--){
                widgetFound = false;
                if(store.state.widgets[i].type == 'temperatureAutomationWidget'){
                  for(j = 0; j < automationWidgets.length; j++){
                    if(store.state.widgets[i].settings.groupId == automationWidgets[j].settings.groupId){
                      widgetFound = true;
                      break;
                    }
                  }
                  if(!widgetFound){
                    if(store.state.widgets[i].hubUUID == hub.uuid){
                      store.commit('deleteWidget', i);
                    }
                  }
                }
              }
              store.commit('saveState');
              resolve();
            })
            .catch( (response) => {
              // console.log(response);
              reject(response);
            })
        })
        .catch( (response) => {
          // console.log(response);
          reject(response);
        })
      })
      .catch( response => {
        // console.log(response);
        reject(response);
      })
    });
  },
}
export default HUB_MESSAGING_COMPLEX;